import React, { useState, useEffect } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '../components/popover';
import { countries } from '../lib/CountryCodes';
import {
    ChevronsUpDownIcon,
} from 'lucide-react';
import {
    Command,
    CommandEmpty,
    CommandGroup,
    CommandInput,
    CommandItem,
    CommandList,
} from '../components/command';
import ReactCountryFlag from "react-country-flag";
interface CountrySelectProps {
    field: { value?: string, onChange: (value: string) => void };
}

const CountrySelect: React.FC<CountrySelectProps> = ({
    field,
}) => {
    const [value, setValue] = useState(field?.value ?? '')
    const [open, setOpen] = React.useState(false);

    // Sync internal state when field.value changes externally (e.g., auto-detection)
    useEffect(() => {
        if (field?.value && field.value !== value) {
            setValue(field.value);
        }
    }, [field?.value]);

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <div
                    role="combobox"
                    aria-expanded={open}
                    className="
            absolute left-0 top-0 h-full w-[80px] border-none bg-transparent px-3 text-sm 
            focus:ring-0 focus:outline-none flex items-center justify-between
            cursor-pointer
          "
                    onClick={() => setOpen(!open)}
                >
                    {value
                        ? countries.find((c) => c.dial_code === value)?.dial_code ?? 'Select'
                        : 'Select'}
                    <ChevronsUpDownIcon className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                </div>
            </PopoverTrigger>

            <PopoverContent className="w-[200px] p-0">
                <Command>
                    <CommandInput placeholder="Search country..." className="h-8 text-xs" />
                    <CommandList>
                        <CommandEmpty>No country code found.</CommandEmpty>
                        <CommandGroup>
                            {countries
                                .sort((a, b) => a.name.localeCompare(b.name))
                                .map((country) => (
                                    <CommandItem
                                        key={country.name}
                                        value={`${country.name} ${country.dial_code}`}
                                        onSelect={() => {
                                            setValue(country.dial_code);
                                            field.onChange(country.dial_code);
                                            setOpen(false); // ✅ close dropdown after selection
                                        }}
                                        className="cursor-pointer"
                                    >
                                        <ReactCountryFlag
                                            countryCode={country.code}
                                            svg
                                            style={{
                                                width: "1.5em",
                                                height: "1.5em",
                                                marginRight: "5px",
                                            }}
                                        />
                                        <p className="flex items-center gap-2">
                                            {country.name} {country.dial_code}
                                        </p>
                                    </CommandItem>
                                ))}
                        </CommandGroup>
                    </CommandList>
                </Command>
            </PopoverContent>
        </Popover>
    );
};

export default CountrySelect;
